<template>
  <div
    id="dropdown"
    class="relative z-50 inline-block"
  >
    <slot />
    <div
      v-if="isOpen"
      class="fixed inset-0 drop-down-menu"
      tabindex="-1"
      @click="onClose"
    />
    <mj-drop-down-menu
      :is-open="isOpen"
      :direction="direction"
    >
      <slot name="collapsible" />
    </mj-drop-down-menu>
  </div>
</template>

<script>
import DropDownMenu from '@/components/ui/general/dropdown/DropDownMenu.vue';

export default {
  name: 'DropDown',

  components: {
    'mj-drop-down-menu': DropDownMenu,
  },

  props: {
    direction: {
      type: String,
      required: false,
      default: 'left',
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    onClose() {
      this.isOpen = false;
      this.$emit('onClose');
    },
  },
};

</script>
